export const NO_LABEL: string = 'NO_LABEL'
export interface LabelProps {
  labelText?: string
  /** Draws the "required" asterisk. Ignored when `isOptional` is true. */
  isRequired?: boolean
  /** Draws the grey "optional" badge. Ignored when `isRequired` is true. */
  isOptional?: boolean
  /** Tooltip content shown next to the label. */
  tooltipText?: string
  /** Help text rendered under the label. */
  inlineHelpText?: string
  /** Maximum wrapped lines before ellipsis + full-label popover on tap. Defaults to 2. */
  maxLines?: number
}
